
import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, UserPlus, Home, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthProvider';

interface AuthNavigationProps {
  className?: string;
  variant?: "default" | "outline" | "secondary" | "ghost" | "link";
  showHomeWhenAuthenticated?: boolean;
}

const AuthNavigation: React.FC<AuthNavigationProps> = ({ 
  className = "", 
  variant = "default",
  showHomeWhenAuthenticated = true
}) => {
  const { user } = useAuth();
  
  if (user) {
    // If user is authenticated and we should show home button
    if (showHomeWhenAuthenticated) {
      return (
        <Link to="/">
          <Button variant={variant} className={className}>
            <Home className="mr-2 h-4 w-4" />
            Dashboard
          </Button>
        </Link>
      );
    }
    return null; // If user is authenticated but we don't want to show home button
  }
  
  // If user is not authenticated, show sign in and sign up buttons
  return (
    <div className={`flex gap-2 ${className}`}>
      <Link to="/index">
        <Button variant="ghost" size="sm">
          <Info className="mr-2 h-4 w-4" />
          About
        </Button>
      </Link>
      <Link to="/signin">
        <Button variant={variant} size="sm">
          <LogIn className="mr-2 h-4 w-4" />
          Sign In
        </Button>
      </Link>
      <Link to="/signup">
        <Button variant="outline" size="sm">
          <UserPlus className="mr-2 h-4 w-4" />
          Sign Up
        </Button>
      </Link>
    </div>
  );
};

export default AuthNavigation;
